export default __webpack_public_path__ + "static/media/port5.e5698464.jpg";